import Router from 'vue-router'
import beforeEach from './beforeEach'
export default class ExtendRouter extends Router {
  constructor ({ mode = 'history', base = '/api', ...other } = { }) {
    super({ mode, base: base || process.env.BASE_URL, ...other })
    super.beforeEach(beforeEach)
  }
}
